



import { Component, Mixins } from 'vue-property-decorator'
import Collect from '@/components/organisms/study/Collect.vue'
import Contents3 from '@/views/student/study/Contents3.vue'

@Component({
  components: {
    Collect,
  },
})
export default class Collect5 extends Mixins(Contents3) {}
